import { Wording } from '@/types';

export const LOVE_WORDING_SK: Wording = {
  components_header_media_content: 'Zvuky',
  components_header_media_1: 'Meditácie',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Sprievodcovia',
  components_header_text2: 'Blog',
  components_header_members: 'členov',
  hero_text: 'Objavte lásku cez hviezdy',
  hero_button_text: 'Začnite svoju cestu',
  components_ressources_section_title: 'LÁSKA A ASTROLÓGIA',
  components_ressources_subheader_text: 'Vaša nebeská súprava nástrojov pre romantický pohľad',
  components_ressources_span_text: 'Ponorte sa do nášho vesmíru podcastov a článkov zameraných na lásku, kompatibilitu so zverokruhom a kozmické spojenie. Či už hľadáte jasnosť spriaznených duší alebo dekódovanie vzorcov vášho vzťahu, naše zdroje vás vedú k hlbšiemu pochopeniu cez hviezdy.',
  components_ressources_card_1_title: 'Zodiac Love Talks',
  components_ressources_card_1_text: 'Preskúmajte úprimné epizódy podcastov, ktoré sa ponoria do emocionálneho jazyka každého znamenia, milostnej kompatibility, vášne a osobného rastu vo vzťahoch.',
  components_ressources_card_2_title: 'Blog lásky',
  components_ressources_card_2_text: 'Prečítajte si postrehy a úvahy o tom, ako každé znamenie miluje, lieči a spája. Od synastry po planetárnu romantiku, náš blog je vaším sprievodcom astrologickou láskou.',
  components_ressources_link: 'Preskúmať ďalej',
  components_notes_and_google_title_1: 'Romantická astrológia',
  components_notes_and_google_title_2: 'Návyky lásky',
  components_notes_and_google_title_3: 'Úvahy o láske poslucháčov',
  components_review_google_text: 'Čo hovoria naši poslucháči',
  media_content_section_title: 'PODCAST LOVE & ZODIAC',
  media_content_section_subheader_text: 'Skutočný rozhovor o kozmickej romantike',
  text_media_1: 'Nalaďte sa na hlboké, odhaľujúce epizódy o astrologických zápasoch, emocionálnych vzorcoch a romantickej dynamike.',
  text_media_2: '',
  media_content_section_button_more: 'Počúvajte',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Astrologické milostné príbehy a postrehy',
  text2_section_button_more: 'Načítať viac',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Nechajte hviezdy viesť váš milostný príbeh',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Láska a zverokruh: Epizódy podcastov',
  page_media_content_menu_compatibility: 'Kompatibilita',
  page_media_content_menu_love: 'láska',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Preskúmajte lásku prostredníctvom astrológie',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'články',
  enter_email_title: 'Ak chcete pokračovať, zadajte svoj e-mail',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Počúvajte',
  components_card_link_text2_content: 'Prečítajte si články',
  components_card_link_text1_content: '',
  france: 'Francúzsko',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditácia',
  page_media_content_menu_all: 'Všetky',
};